import axios from 'axios';
import Api from '../../Api';

class CharityRepresentativeOnboardingApi extends Api {
  constructor() {
    super('charities/representatives/onboarding', 'charity representative onboarding');
  }

  async complete(charityRepId, onboardingId, completed) {
    let res;
    const errorText = `Could not refresh onboarding for charity id ${charityRepId}`;
    try {
      const url = `/${this.endpoint}/complete?charityRepId=${charityRepId}&onboardingId=${onboardingId}&completed=${completed}`;
      res = await axios.get(url);
      if (res.status === 200) {
        res = res.data;
      } else {
        console.error(errorText);
        res = false;
      }
    } catch (e) {
      console.error(errorText);
      console.error(e);
      res = false;
    }
    return res;
  }
}

const charityRepresentativeOnboardingApi = new CharityRepresentativeOnboardingApi();
export default charityRepresentativeOnboardingApi;
